module.exports = __webpack_public_path__ + "img/payment_summary.0db21216.svg";